import { render } from "./evaluation.vue?vue&type=template&id=8aaed960"
import script from "./evaluation.vue?vue&type=script&lang=js"
export * from "./evaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__